import {
    Comparison,
    isExactComparison,
    isMembershipComparison,
    isRangeComparison,
} from 'utils/components/FiltersModal/comparison/FilterComparison';
import {
    ExactSign,
    filterValueTypeHandlesValueType,
    mapValueTypeToFilterValueType,
    MembershipSign,
} from 'utils/filter/filter';

import {
    ColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';
import { ComparisonGroupProps } from 'utils/components/FiltersModal/comparison/ComparisonGroup';
import { EditedColumnNames } from 'grid/columnNames/hooks';

export function computeComparisonGroupProps<
    TColumnId extends string,
    TDataItem,
>(
    columnDefinitionsPortfolio: ColumnDefinitionsDictionary<TColumnId>,
    column: TColumnId | undefined,
    pendingComparison: Comparison | undefined,
    setPendingComparison: (
        comparison: Comparison | undefined,
        commitOnSet?: boolean
    ) => void,
    editedColumnNames?: EditedColumnNames
): Partial<ComparisonGroupProps<TDataItem>> {
    if (!column) {
        return {
            columnName: undefined,
            comparison: undefined,
            setComparison: undefined,
        };
    }

    const columnName =
        (editedColumnNames ?? {})[column] ??
        columnDefinitionsPortfolio[column].name;
    const columnValueType = columnDefinitionsPortfolio[column].valueType;
    const fieldName = columnDefinitionsPortfolio[column].field;

    if (
        pendingComparison &&
        (((isExactComparison(pendingComparison) ||
            isMembershipComparison(pendingComparison)) &&
            filterValueTypeHandlesValueType(
                pendingComparison.valueType,
                columnValueType
            )) ||
            (isRangeComparison(pendingComparison) &&
                filterValueTypeHandlesValueType(
                    pendingComparison[0].valueType,
                    columnValueType
                ) &&
                filterValueTypeHandlesValueType(
                    pendingComparison[1].valueType,
                    columnValueType
                )))
    ) {
        return {
            columnName,
            fieldName,
            enumMap: columnDefinitionsPortfolio[column].enumMap,
            comparison: pendingComparison,
            setComparison: setPendingComparison,
        };
    }

    if (columnValueType === ValueType.STRING) {
        return {
            columnName,
            fieldName,
            comparison: {
                valueType: ValueType.STRING,
                sign: MembershipSign.INCLUDE,
                values: [],
            },
            setComparison: setPendingComparison,
        };
    }

    if (columnValueType === ValueType.ENUM) {
        return {
            columnName,
            fieldName,
            enumMap: columnDefinitionsPortfolio[column].enumMap,
            comparison: {
                valueType: ValueType.ENUM,
                sign: MembershipSign.INCLUDE,
                values: [],
            },
            setComparison: setPendingComparison,
        };
    }

    return {
        columnName,
        fieldName,
        comparison: {
            valueType: mapValueTypeToFilterValueType(columnValueType),
            sign: ExactSign.EQ,
            value: undefined,
        },
        setComparison: setPendingComparison,
    };
}
